import styled from "styled-components";
import * as M from "@discovery/prelude/lib/data/maybe";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Video } from "../video-page/optics/player";
import { primaryFontFamilyBold } from "../../styles/fontFamilyTypes";
import { neutral10 } from "../../css/colors";
import { Carousel } from "../../components/organisms/sizzle-reel";
import { media } from "../../styles/breakpoints";
import { Container78VW as Container } from "../../styles/common";
const _ImageData = Fold.compose(Optics._Col2Items, Optics._ColItem2Video, Fold.compose(Res._Rel("images"), Res._ForEach(), Res._Response()));
const BASIC = "basic";
export const Title = styled.span `
  font-family: ${primaryFontFamilyBold};
  font-size: 32px;
  color: ${neutral10};
  text-align: center;
  padding: 35px 0px;

  @media ${media.medium.down} {
    padding: 21px 34px 10px 34px;
    font-size: 16px;
    line-height: 1.38;
  }
`;
const InnerContainer = styled.div `
  display: flex;
  justify-content: center;
`;
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    const templateIdM = Fold.preview(Optics._Col2TemplateId, data);
    const streamIdM = Fold.preview(_Video, data);
    const imageDataM = Fold.preview(_ImageData, data);
    return {
        titleM,
        templateIdM,
        streamIdM,
        imageDataM,
    };
};
const SizzleReel = ({ titleM, templateIdM, streamIdM, imageDataM, environment, }) => {
    const templateId = M.fromMaybe(templateIdM, "");
    const BasicView = () => {
        return (React.createElement(Container, null,
            React.createElement(InnerContainer, null,
                React.createElement(RenderMaybe, null, M.map((title) => (title ? React.createElement(Title, null, title) : ""), titleM))),
            React.createElement(Carousel, { streamIdM: streamIdM, environment: environment, imageDataM: imageDataM })));
    };
    switch (templateId) {
        case BASIC:
            return React.createElement(BasicView, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, SizzleReel);

